// Taalbepaling (spiegelt backend i18n.py): nl/en/de o.b.v. land organisatie.
const TWEETALIG = {
  "belgië": "nl", "belgie": "nl", "belgium": "nl", "belgique": "nl",
  "zwitserland": "de", "switzerland": "de", "suisse": "de", "schweiz": "de",
  "luxemburg": "de", "luxembourg": "de",
};
const NL = new Set(["nederland", "nl", "netherlands", "holland", "the netherlands"]);
const DE = new Set(["duitsland", "de", "germany", "deutschland", "oostenrijk", "austria", "österreich"]);
const EN = new Set(["verenigd koninkrijk", "uk", "engeland", "england", "ierland", "ireland",
  "united kingdom", "verenigde staten", "usa", "us", "united states", "scotland", "wales"]);

export const TAAL_LABELS = { nl: "Nederlands", en: "Engels", de: "Duits" };

export function resolveTaal(land) {
  const l = (land || "").trim().toLowerCase();
  if (!l || NL.has(l)) return "nl";
  if (DE.has(l)) return "de";
  if (EN.has(l)) return "en";
  if (l in TWEETALIG) return TWEETALIG[l];
  return "en";
}

export function isTweetalig(land) {
  return ((land || "").trim().toLowerCase()) in TWEETALIG;
}
